<template>
  <div class="hover-table">
    <o-table
      class="ma-2"
      v-if="receivedQuestionnaires?.length > 0"
      :data="tableData"
      hoverable
      persistent
      @click="viewQuestionnaireStatus"
      paginated
      :checkable="chooseMultiple"
      v-model:checked-rows="selectedQuestionnaires"
    >
      <o-table-column
        v-slot="props"
        field="questionnaireLabel"
        label="Questionnaire name"
        sortable
      >
        <p>{{ props.row.questionnaireLabel }}</p>
      </o-table-column>

      <o-table-column
        v-slot="props"
        field="senderCompanies"
        label="Sender"
        sortable
      >
        <p>{{ props.row.senderCompanies }}</p>
      </o-table-column>

      <o-table-column
        v-slot="props"
        field="answerStatus"
        label="Questionnaire"
        sortable
      >
        <QuestionnaireStatusBadge :status="props.row.answerStatus" />
      </o-table-column>

      <o-table-column
        v-slot="props"
        field="forwardingStatus"
        label="Forwarding"
        sortable
      >
        <QuestionnaireStatusBadge
          v-if="!props.row.isBusinessPartner"
          :status="props.row.forwardingStatus"
        />
      </o-table-column>
    </o-table>
  </div>
</template>

<script setup lang="ts">
import type ReceivedQuestionnaire from "@/models/receivedQuestionnaire";
import { ref, computed, type Ref, watch } from "vue";
import QuestionnaireStatusBadge from "@/components/custom/QuestionnaireStatusBadge.vue";
import type { AnswerStatus } from "@/models/enum/answerStatus";
import type { ForwardingStatus } from "@/models/enum/forwardingStatus";

interface ReceivedQuestionnaireTableRow {
  questionnaireLabel: string;
  senderCompanies: string;
  answerStatus: AnswerStatus;
  forwardingStatus: ForwardingStatus;
  receivedQuestionnaire: ReceivedQuestionnaire;
  isBusinessPartner: boolean;
}

const props = defineProps<{
  receivedQuestionnaires: ReceivedQuestionnaire[];
  chooseMultiple: boolean;
}>();

const emit = defineEmits<{
  (e: "viewQuestionnaireStatus", questionnaire: ReceivedQuestionnaire): void;
  (
    e: "selectedQuestionnairesUpdated",
    questionnaires: ReceivedQuestionnaire[]
  ): void;
}>();

function stringifySuppliers(supplierList: string[]): string {
  return supplierList.join(", ");
}

function viewQuestionnaireStatus(tableRow: any): void {
  emit("viewQuestionnaireStatus", tableRow.receivedQuestionnaire);
}

const selectedQuestionnaires: Ref<ReceivedQuestionnaireTableRow[]> = ref([]);

const tableData = computed(() =>
  props.receivedQuestionnaires.map((q) => ({
    questionnaireLabel: q.questionnaireLabel,
    senderCompanies: stringifySuppliers(q.senderCompanies),
    answerStatus: q.answerStatus,
    forwardingStatus: q.forwardingStatus,
    receivedQuestionnaire: q,
    isBusinessPartner: q.isBusinessPartner,
  }))
);

watch(
  selectedQuestionnaires,
  (
    newQuestionnaires: ReceivedQuestionnaireTableRow[],
    oldQuestionnaires: ReceivedQuestionnaireTableRow[]
  ) => {
    var questionnaires = newQuestionnaires.map((q) => q.receivedQuestionnaire);
    emit("selectedQuestionnairesUpdated", questionnaires);
  }
);
</script>

<style scoped lang="scss">
.hover-table:hover {
  cursor: pointer;
}
</style>
